<div>
    <app-car-search
        [businessLine] = businessLine!>

    </app-car-search>
</div>
